import { siteData } from '@/data/siteData';

export function Footer() {
  return (
    <footer className="bg-brand-navy text-brand-light pt-16 pb-8 border-t border-brand-gold/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="col-span-1 md:col-span-1">
            <div className="flex items-center gap-2 mb-6">
              <img src="/images/logo.jpg" alt="Logo" className="h-10 w-10" />
              <span className="text-2xl font-serif font-bold text-white tracking-tight">
                Hess
              </span>
            </div>
            <p className="text-brand-light/60 text-sm leading-relaxed mb-6">
              Providing dignified, compassionate funeral services to families in Grabouw,
              Caledon and surrounding areas.
            </p>
            <div className="flex gap-4">
              <a
                href={siteData.social.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-brand-gold/10 flex items-center justify-center text-brand-gold hover:bg-brand-gold hover:text-brand-navy transition-all"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.09 3.056 9.41 7.324 11.171v-2.605h-3.278v-3.576h3.278v-1.951c0-1.393.35-2.49 2.256-2.49h2.437v3.239h-1.375c-1.448 0-1.719.804-1.719 1.822v1.752h3.5l-.406 3.576h-3.094v7.094h4.21c3.565 0 6.573-2.823 6.573-6.749v-5.954z" />
                </svg>
              </a>
              <a
                href={`https://wa.me/${siteData.whatsappPhone.replace('+', '')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-brand-gold/10 flex items-center justify-center text-brand-gold hover:bg-brand-gold hover:text-brand-navy transition-all"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.626 3.127C16.199 1.052 11.716.197 6.75.197C1.782.197 0 1.979 0 6.947c0 4.818 3.203 9.287 8.13 11.852-.017.101-.085.27-.085.372v2.078c0 .533.468.966 1.043.966h2.048c.575 0 1.043-.433 1.043-.967v-2.07c0-.102-.068-.271-.085-.372 4.925-2.565 8.13-7.034 8.13-11.852C24 1.979 22.218.197 17.25.197c-4.968 0-9.45.855-13.876 2.93C1.855 7.039 0 9.232 0 11.808c0 2.34 1.054 4.533 2.914 6.047-.017.1-.084.27-.084.371v2.078c0 .534.468.967 1.043.967h2.048c.575 0 1.043-.433 1.043-.967v-2.07c0-.102-.068-.271-.085-.372 1.859-1.514 2.914-3.707 2.914-6.047C6.75 9.232 5.695 7.039 3.837 5.527c4.426-2.075 8.908-2.93 13.876-2.93 4.968 0 9.45.855 13.876 2.93C22.946 7.039 24 9.232 24 11.808c0 2.34-1.054 4.533-2.914 6.047-.017.1-.084.27-.084.371v2.078c0 .534.468.967 1.043.967h2.048c.575 0 1.043-.433 1.043-.967v-2.07c0-.101-.067-.271-.084-.372 1.86-1.514 2.914-3.707 2.914-6.047C24 1.979 22.218.197 17.25.197c-1.39 0-2.756.223-4.064.644 3.314-1.629 5.44-5.078 5.44-9.114z" />
                </svg>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white font-serif font-bold text-lg mb-6">Locations</h4>
            {siteData.locations.map((loc) => (
              <div key={loc.name} className="mb-4">
                <p className="text-brand-light text-sm font-medium">{loc.name}</p>
                <p className="text-brand-light/60 text-sm">{loc.address}</p>
              </div>
            ))}
          </div>

          <div>
            <h4 className="text-white font-serif font-bold text-lg mb-6">Contact</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-2">
                <span className="text-brand-gold mt-0.5">📞</span>
                <p className="text-brand-light text-sm">{siteData.locations[0].officePhone}</p>
              </div>
              <div className="flex items-start gap-2">
                <span className="text-brand-gold mt-0.5">📱</span>
                <p className="text-brand-light text-sm">{siteData.locations[0].mobilePhone}</p>
              </div>
              <div className="flex items-start gap-2">
                <span className="text-brand-gold mt-0.5">✉</span>
                <p className="text-brand-light text-sm">{siteData.email}</p>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-white font-serif font-bold text-lg mb-6">Agent</h4>
            <div className="space-y-3">
              <p className="text-brand-light text-sm font-medium">{siteData.agent.name}</p>
              <p className="text-brand-light text-sm">{siteData.agent.phone}</p>
              <p className="text-brand-light text-sm">{siteData.agent.phoneAlt}</p>
            </div>
          </div>
        </div>

        <div className="border-t border-brand-gold/10 pt-8 mt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-brand-light/50">
          <p>
            {siteData.name} is underwritten by Salam Developing Markets Limited (Reg no. 1911/003318/06)
          </p>
          <p className="text-center md:text-left">
            &copy; {new Date().getFullYear()} {siteData.name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}